<div class="success-message-container">
  <mat-icon color="primary">error</mat-icon>
  <div class="success-message">
    <ng-content></ng-content>
  </div>
  <button mat-icon-button (click)="dismiss.emit()">
    <mat-icon color="primary">close</mat-icon>
  </button>
</div>
